import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import { WebSocketService } from '../../../../client/app/server-communication/services/websocket.service';
import { WebSocketMessageType } from '../../../../model/web-socket-message';
import ErrorLogsActions from './error-logs.action-types';

@Injectable()
export class ErrorLogsEffects {
    constructor(private readonly actions$: Actions, private readonly webSocketService: WebSocketService) {}

    requestErrorLogs$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(ErrorLogsActions.requestErrorLogs),
                map(action => action.locationContext),
                tap(locationContext =>
                    this.webSocketService.sendMessage(WebSocketMessageType.ErrorLogs, { locationContext })
                )
            ),
        { dispatch: false }
    );
}
